import { defineComponent as _defineComponent } from 'vue'
import { toastService } from 'affolternet-vue3-library'
import { getFile, settings } from "@/services/Storage"
import { required, helpers } from '@vuelidate/validators';
import { computed, nextTick, reactive } from 'vue';
import useValidate from '@vuelidate/core'
import { formatPhone, invalidPhoneMsg, phoneValidator, requiredMsg } from '@/validation/validationHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsCalAbo',
  setup(__props, { expose }) {
  expose();


const reg = reactive<{ phoneinput: string }>({
  phoneinput: settings.phoneNumber
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const customUrl = computed(() => `${url}?searchstring=${encodeURIComponent(reg.phoneinput)}`)

const rules = computed(() => {
  return {
    phoneinput: { 
      required: helpers.withMessage(requiredMsg, required),
      phone: helpers.withMessage(invalidPhoneMsg, phoneValidator)
    },
  }
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const v$ = useValidate(rules, reg, { $autoDirty: true })

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const url = `${window.location.protocol}//${window.location.host}/api/ical/${getFile(true)}`

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const copy = (text: string) => {
  if (!navigator.clipboard) {
    toastService.showError('Kopieren in die Zwischenablage wird von deinem Browser nicht unterstützt.')
    return;
  }
  navigator.clipboard.writeText(text.replace('+', '%2b')).then(function() {
    toastService.showDone('URL wurde in die Zwischenablage kopiert.')
  }, function() {
    toastService.showError('Kopieren in die Zwischenablage ist fehlgeschlagen. Bitte den Text "von Hand" kopieren.')
  });
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const format = () => {
  nextTick(() => {
    if (v$.value.phoneinput.$error) {
      return
    }
    const phone = formatPhone(reg.phoneinput)
    if (phone) {
      reg.phoneinput = phone
    }
  })
}


const __returned__ = { reg, customUrl, rules, v$, url, copy, format, toastService, getFile, settings, required, helpers, computed, nextTick, reactive, useValidate, formatPhone, invalidPhoneMsg, phoneValidator, requiredMsg }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})